import {
  GlossaryIndexColumns,
  GlossaryIndexTermSkeleton,
} from '@vs-shop/commerce-ui/glossaryIndex';

type Props = {
  count?: number;
};

export function GlossarySkeletonGrid({ count = 15 }: Props) {
  return (
    <GlossaryIndexColumns className="max-w-[1240px] py-8">
      {Array.from({ length: count }, (_, i) => (
        <GlossaryIndexTermSkeleton key={`glossary-skeleton-${String(i)}`} />
      ))}
    </GlossaryIndexColumns>
  );
}
